import { render } from "./InventoryReportsPage.vue?vue&type=template&id=7f50d0ea"
import script from "./InventoryReportsPage.vue?vue&type=script&lang=js"
export * from "./InventoryReportsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__